// extracted by mini-css-extract-plugin
export default {"label":"label__U6NeL","rtf_editor":"rtf_editor__e7oER","rtf_error":"rtf_error__PQ42a"};